import { isArray } from "lodash";

function HelperRemoveNullValues(
  obj: any,
  opt?: {
    removeEmptyStrings?: boolean;
    removeEmptyArray?: boolean;
    removeBoleanFalse?: boolean;
  }
) {
  for (const key in obj) {
    if (obj[key] === 0 || obj[key] === false) {
      if (opt?.removeBoleanFalse) {
        delete obj[key];
      } else {
        obj[key] = 0;
      }
    } else if (obj[key] === true || obj[key] === 1) {
      obj[key] = 1;
    } else if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    } else if (
      isArray(obj[key]) &&
      obj[key].length === 0 &&
      opt?.removeEmptyArray
    ) {
      delete obj[key];
    } else if (obj[key] === "" && opt?.removeEmptyStrings) {
      delete obj[key];
    }
  }
  return obj;
}

export default HelperRemoveNullValues;
